export enum HolidayFlag {
    A = 'Whole Day',
    P = 'Half Day',
}

export type HolidayFlagValue = keyof typeof HolidayFlag;
